var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.9948 8.98242C19.9948 9.61523 19.4739 10.1109 18.8836 10.1109H17.7723L17.7967 15.743C17.7967 15.8379 17.7897 15.9328 17.7793 16.0277V16.5938C17.7793 17.3707 17.1577 18 16.3903 18H15.8347C15.7965 18 15.7583 18 15.7201 17.9965C15.6715 18 15.6229 18 15.5742 18H14.4457H13.6123C12.8448 18 12.2233 17.3707 12.2233 16.5938V15.75V13.5C12.2233 12.8777 11.7267 12.375 11.1121 12.375H8.88965C8.27501 12.375 7.77844 12.8777 7.77844 13.5V15.75V16.5938C7.77844 17.3707 7.15686 18 6.38943 18H5.55603H4.4483C4.39621 18 4.34412 17.9965 4.29203 17.993C4.25036 17.9965 4.20869 18 4.16702 18H3.61142C2.84399 18 2.22241 17.3707 2.22241 16.5938V12.6562C2.22241 12.6246 2.22241 12.5895 2.22588 12.5578V10.1109H1.11121C0.486152 10.1109 0 9.61875 0 8.98242C0 8.66602 0.104176 8.38477 0.347252 8.13867L9.25079 0.28125C9.49386 0.0351562 9.77166 0 10.0147 0C10.2578 0 10.5356 0.0703125 10.744 0.246094L19.6128 8.13867C19.8906 8.38477 20.0295 8.66602 19.9948 8.98242Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.973ade6a9e35c7458f6879e49c0855e7.svg";
export { ForwardRef as ReactComponent };